import { useQuery } from '@tanstack/react-query';
import { api } from './api';
import type { AiStatus } from './types';

export function useAiStatus() {
  return useQuery({ queryKey: ['ai-status'], queryFn: () => api.get<AiStatus>('/ai/status'), staleTime: 60_000 });
}

export const SUGGESTION_KIND_LABELS: Record<string, string> = {
  evidence: 'evidência candidata',
  signal: 'sinal',
  observation: 'observação',
  question: 'pergunta',
  contradiction: 'contradição',
  relation: 'relação',
  hypothesis: 'hipótese',
  cycle_question: 'pergunta do ciclo',
};
export const FEATURE_LABELS: Record<string, string> = {
  extract: 'leitura da fonte',
  make_visible: 'tornar visível',
  challenge: 'remar contra',
  connect: 'o que conecta isso?',
  ask: 'pergunte à Machine',
  classify: 'classificação',
  find: 'encontrar',
  session_agenda: 'pauta de sessão',
  session_summary: 'resumo de sessão',
  frame: 'enquadrar',
  fill: 'preencher',
  interview: 'conversa',
  solution: 'a solução',
  synthesize: 'síntese do ciclo',
  serendipity: 'serendipidade',
};
